import styled from 'styled-components/macro';
import {
    Button,
    Checkbox,
    FormControl,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useToast,
} from "@chakra-ui/react";
import {useFeedback} from "../../../store/feedback";
import {useState} from "react";
import {useRemoveModerator, useUpdateModerator} from "../../../api/moderation";

const ModeratorDetails = styled(({className, community, moderator, setTime, onClose}) => {
    const {feedbackCh} = useFeedback();
    const [info, setInfo] = useState({
        community: community,
        author: moderator.author,
        all_permissions: moderator.permissions.all_permissions,
        manage_rules: moderator.permissions.manage_rules,
        manage_automoderator: moderator.permissions.manage_automoderator,
        manage_settings: moderator.permissions.manage_settings,
        manage_stylesheet: moderator.permissions.manage_stylesheet,
        manage_sidebar: moderator.permissions.manage_sidebar,
    });
    const set = (name) => (value) => setInfo((info) => ({...info, [name]: value}));
    const toast = useToast();
    const removeModerator = useRemoveModerator(feedbackCh);
    const updateModerator = useUpdateModerator(feedbackCh);
    const handleRemove = async () => {
        await removeModerator(community, moderator.author);
        toast({
            title: `Successfully removed.`,
            status: 'success',
            isClosable: true,
        });
        setTime(Date.now());
        onClose();
    };
    const handleSave = async () => {
        await updateModerator(info);
        toast({
            title: `Successfully updated!`,
            status: 'success',
            isClosable: true,
        });
        setTime(Date.now());
        onClose();
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Moderator Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl pb={1} pt={4}>
                        <Checkbox size='md' value={info.all_permissions} defaultChecked={info.all_permissions}
                                  onChange={(e) => set('all_permissions')(e.target.checked)}>All Permissions</Checkbox>
                    </FormControl>
                    <FormControl pb={1}>
                        <Checkbox size='md' value={info.manage_rules} defaultChecked={info.manage_rules}
                                  onChange={(e) => set('manage_rules')(e.target.checked)}>Manage Rules</Checkbox>
                    </FormControl>
                    <FormControl pb={1}>
                        <Checkbox size='md' value={info.manage_sidebar} defaultChecked={info.manage_sidebar}
                                  onChange={(e) => set('manage_sidebar')(e.target.checked)}>Manage Sidebar</Checkbox>
                    </FormControl>
                    <FormControl pb={1}>
                        <Checkbox size='md' value={info.manage_automoderator} defaultChecked={info.manage_automoderator}
                                  onChange={(e) => set('manage_automoderator')(e.target.checked)}>Manage Filter</Checkbox>
                    </FormControl>
                    <FormControl pb={1}>
                        <Checkbox size='md' value={info.manage_settings} defaultChecked={info.manage_settings}
                                  onChange={(e) => set('manage_settings')(e.target.checked)}>Manage Settings</Checkbox>
                    </FormControl>
                    <FormControl>
                        <Checkbox size='md' value={info.manage_stylesheet} defaultChecked={info.manage_stylesheet}
                                  onChange={(e) => set('manage_stylesheet')(e.target.checked)}>Manage Stylesheet</Checkbox>
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={handleRemove}>
                        Remove
                    </Button>
                    <Button variant="blue" onClick={handleSave}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default ModeratorDetails;
